import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { setToastAction } from "../../store/reducers/mmymSlice";

const Toast = () => {
  const { addToast } = useToasts();
  const { toast } = useSelector((state: any) => state.mmym);
  const dispatch = useDispatch();

  useEffect(() => {
    if (toast?.message) {
      const toastHeight = toast?.message?.length > 38 ? "auto" : "34px";
        console.log('toast called')
      addToast(toast?.message, {
        appearance: toast?.appearance,
        autoDismiss: true,
        style: {
          zIndex: 999999999999,
          height: toastHeight,
        },
      });
      dispatch(setToastAction({message: '', appearance: 'error'}))
    }
  }, [toast]);

  return null;
};

export default Toast;